import React from 'react';

export const AccordionContext = React.createContext<IAccordionContext>({
  expanded: false,
  disabled: false,
  id: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggle: () => {},
});

interface IAccordionContext {
  expanded: boolean;
  disabled: boolean;
  id: string;
  toggle: (event?: React.MouseEvent<HTMLElement>) => void;
}
